<script>
import { api } from '@/modules/api'
import { toast } from 'vue3-toastify'
import AccountInformations from "@/components/profil/AccountInformations.vue"
import PanelLinkAccount from "@/components/profil/PanelLinkAccount.vue"
import Cookies from "js-cookie"
import {mapStores} from "pinia"
import {useAuthStore} from "@/stores/auth"

export default {
  name: 'ViewProfil',
  components: {PanelLinkAccount, AccountInformations},
  data () {
    return {
      profil: {},
      notify: null
    }
  },
  mounted () {
    this.loadData()
    this.emitter.on('load-data', () => {
      this.loadData()
    })
    this.notify = () => {
      toast("Easter egg trouvé 👏 !");
    }
  },
  computed: {
    ...mapStores(useAuthStore),
  },
  methods: {
    loadData () {
      api.profil.get().then(response => {
        this.profil = response
      })
    },
    logout () {
      Cookies.remove('token')
      Cookies.remove('user')
      this.authStore.logout()
      this.$router.push('/')
    }
  }
}
</script>

<template>
  <section class="bg-white py-8 antialiased dark:bg-gray-900">
    <div class="mx-auto max-w-screen-xl px-4 2xl:px-0">
     <div class="flex justify-between w-full">
       <h2 @click="notify" class="mb-2 text-lg uppercase text-primary-700/60 font-bold sm:text-xl md:mb-2">
         Votre compte déglingo
       </h2>
       <button @click="logout" class="mr-5 text-gray-700/50 hover:underline uppercase text-sm flex items-center">
         <span class="span">Me déconnecter</span>
         <i class="fa-solid fa-right-from-bracket ml-5"></i>
       </button>
     </div>
      <hr class="mt-5 mb-12 h-0.5 border-t-0 bg-neutral-100 dark:bg-white/10" />
      <div class="flex flex-wrap">
        <panel-link-account :profil="profil" />
        <account-informations :profil="profil" />
      </div>
    </div>
  </section>
</template>

<style scoped>
.button i {
  transition: color 0.3s ease-in-out;
}

.button {
  transition: all 0.3s ease-in-out;
}

.button:hover i {
  color: white!important;
  transition: color 0.3s ease-out;
}

@media (max-width: 1024px) {
  .span {
    display: none;
  }
}
</style>
